import React, { PureComponent } from "react";
import { connect } from "react-redux";
import getConfig from "next/config";
import Link from "next/link";
import ArrowDown from "@components/Icons/ArrowDown";

const {
  publicRuntimeConfig: {
    settings,
    content: {
      supportMenuLinks: { stores, contact },
    },
  },
} = getConfig();

const isBricoStore = settings.websiteName === "bricostore";

class Sidebar extends PureComponent {
  state = {
    mergedItems: [...this.props.items, stores, contact],
    activeIndex: [],
    activeSlug: "",
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { currentUrl } = nextProps,
      nextActiveSlug = getActiveSlugFromUrl(currentUrl),
      { mergedItems, activeSlug } = prevState;
    let { activeIndex } = prevState;

    if (nextActiveSlug !== activeSlug) {
      for (let i = 0; i < mergedItems.length; i++) {
        const { children: articles, links } = mergedItems[i],
          itemChild = articles || links;
        let newActiveIndex = null;

        for (let child of itemChild) {
          if (nextActiveSlug.includes(child.slug)) {
            newActiveIndex = [i];
            break;
          }
        }

        if (newActiveIndex) {
          activeIndex = newActiveIndex;
          break;
        }
      }
    }

    return { ...prevState, activeIndex, activeSlug: nextActiveSlug };
  }

  setActiveIndex = (index) => {
    const { activeIndex } = this.state;

    this.setState({
      activeIndex: activeIndex.includes(index)
        ? activeIndex.filter((i) => i !== index)
        : [...activeIndex, index],
    });
  };

  render() {
    const { mergedItems, activeIndex, activeSlug } = this.state;
    const activeSlugNoHost = activeSlug.replace(settings.baseUrl, "");
    const { back } = this.props;

    if (!mergedItems || !mergedItems.length) {
      return null;
    }

    return (
      <>
        <Link
          href={
            back && back.slug
              ? `${settings.baseUrl}${back.slug}`
              : `${settings.baseUrl}/suport-clienti/`
          }
          passHref
        >
          <a className="block lg:hidden text-sm text-red-brand leading-18.2 -tracking-0.29">
            <span className="inline-block rotate-90 mr-2">
              <ArrowDown />
            </span>

            {back && back.title ? back.title : `Inapoi la meniu`}
          </a>
        </Link>

        <div className="hidden lg:block text-left border rounded-tr-xl rounded-bl-xl border-gray-1100 bg-white">
          {mergedItems.map((item, i) => {
            const { children: articles, links } = item,
              isActive = activeIndex.includes(i);

            return (
              <div
                key={item.name}
                className={i !== 0 ? "border-t border-gray-1100" : ""}
              >
                <div
                  className={`
                    flex items-center cursor-pointer px-4 py-2 border-l-4
                    ${
                      isActive
                        ? isBricoStore
                          ? "border-red-brand"
                          : "border-primary"
                        : "border-transparent"
                    }
                  `}
                  onClick={() => this.setActiveIndex(i)}
                >
                  <div
                    className={`grow -tracking-0.39 pr-2 text-sm sm:hover:text-red-brand ${
                      isActive ? "text-newGray-mildDark" : ""
                    }`}
                  >
                    {item.name}
                  </div>
                  <div
                    className={`duration-75 ${isActive ? "rotate-180" : ""}`}
                  >
                    <ArrowDown width="9px" height="9px" />
                  </div>
                </div>

                <ul
                  className={`m-0 px-10 py-15px border-gray-1100 border-t font-normal text-15px ${
                    isActive ? "" : "hidden"
                  }`}
                >
                  {articles &&
                    articles.map((article) => (
                      <RenderMenuSubItem
                        item={article}
                        key={article.slug}
                        isActive={activeSlugNoHost === article.slug}
                        link={`${settings.baseUrl}/suport-clienti/${article.slug}/`}
                      />
                    ))}

                  {links &&
                    links.map((link) => (
                      <RenderMenuSubItem
                        item={link}
                        key={link.slug}
                        isActive={activeSlugNoHost === link.slug}
                        link={
                          link.slug.startsWith("http")
                            ? link.slug
                            : `${settings.baseUrl}${link.slug}`
                        }
                      />
                    ))}
                </ul>
              </div>
            );
          })}
        </div>
      </>
    );
  }
}

const getActiveSlugFromUrl = (currentUrl) => {
  const { query, urlAsPath, asPath } = currentUrl;
  return query.category || urlAsPath || asPath;
};

const RenderMenuSubItem = ({ item, link, isActive }) => (
  <li key={item.slug} style={{ paddingTop: "4px", paddingBottom: "4px" }}>
    {isActive ? (
      <span className="inline-block text-newGray-mildDark leading-24 -tracking-0.29">
        {item.name}
      </span>
    ) : (
      <Link href={link} passHref>
        <a className="inline-block text-black hover:text-red-brand leading-24 -tracking-0.29 mb">
          {item.name}
        </a>
      </Link>
    )}
  </li>
);

export default connect((state) => ({
  currentUrl: state.navigation.currentUrl,
}))(Sidebar);
